import axiosInterceptor from 'services/axiosInterceptor'
import { API_BASE_URL } from 'services/constants'

/**
 * The Home briefing (MYD-638): `GET /api/ai/briefing`, behind AI Assist's
 * guards. One per user per day on the server; `refresh` asks for a new one,
 * which the server grants at most every few minutes.
 *
 * Imports the interceptor directly rather than through the `services` barrel,
 * for the reason explained in features/Explorer/services/explorerService.ts.
 */

export type BriefingHighlightKind = 'approval' | 'overdue' | 'dueSoon' | 'activity'

export interface BriefingHighlight {
	kind: BriefingHighlightKind
	text: string
	/** An in-app path, set by the server from the record the highlight is about. */
	link: string | null
}

export interface Briefing {
	day: string
	headline: string
	highlights: BriefingHighlight[]
	counts: { overdue: number; dueSoon: number; approvals: number; activity: number }
	/** 'model' when the AI wrote it; 'plain' when it was written from the counts. */
	source: 'model' | 'plain'
	generatedAt: string
	cached?: boolean
	/** The AI budget was spent, so this is the plain briefing. */
	limited?: boolean
}

export async function getBriefing({ refresh = false }: { refresh?: boolean } = {}): Promise<Briefing> {
	const { data } = await axiosInterceptor(API_BASE_URL).get<Briefing>('/ai/briefing', { params: refresh ? { refresh: 1 } : undefined })
	return data
}
